<template>
    <v-row no-gutters class="text-center">
        <v-col>
            RESULTADOS LOTERIAS
        </v-col>

        <v-col>
            HOY
        </v-col>
        <v-col>
            {{ date }}
        </v-col>
        <v-col cols="xs-12">
            <div class="contenedor">
                <div class="reloj">
                    <div>{{ time }}</div>
                </div>
            </div>
        </v-col>
          
        <!-- <v-col class="d-flex justify-center align-center">
            <slot name="buttons"></slot>
        </v-col> -->
    </v-row>
</template>

<script>
export default {
    name: "RelojDigital",
    data() {
        return {
            time: '-- : -- : --',
            date: '',
        }
    },
    mounted() {
        setInterval(() => this.setTiempo(), 1000)
        this.date = this.printDate();
    },
    methods: {
        setTiempo() {
            const date = new Date();
            let time = date.toLocaleString('es-VE', { timeZone: 'America/Caracas', timeStyle: 'medium' });
            this.time = time;
        },
        printDate() {
            return new Date().toLocaleDateString();
        },
    }
}
</script>

<style scoped>
* {
    font-size: 2.7vh;
    /* font-size: 25px; */
}

.reloj {
    display: inline-flex;
}
</style>